import React from 'react';

import './CatalogPagination.scss';

const CatalogPagination = ({ onPage, page, pages }) => (
  <div className='catalogs-pagination'>
    <button disabled={page === 0} onClick={() => onPage(page - 1)}>
      Previous
    </button>
    <span>
      Page {page + 1} of {pages}
    </span>
    <button disabled={page >= pages - 1} onClick={() => onPage(page + 1)}>
      Next
    </button>
  </div>
);

export default CatalogPagination;
